import React from "react";
import { FiGithub } from "react-icons/fi";
import { HiDownload } from "react-icons/hi";

const Banner = () => {
  return (
    <div
      id="banner"
      className="hero flex justify-between items-center flex-col lg:flex-row-reverse lg:mt-36"
    >
      <img
        src="https://i.ibb.co/w6fsbLz/6-DF9672-C-F86-B-472-E-BA6-C-5-A64580-DBD14-removebg-2.png"
        className="w-full lg:w-1/3 max-w-lg border-4 border-black rounded-full bg-neon mb-4 lg:mb-0"
        alt=""
      />
      <div>
        <h1 className="text-5xl lg:text-8xl text-center lg:text-left font-bold">
          Farhat Omar Mahi
        </h1>
        <p className="py-6 text-2xl lg:text-3xl text-center lg:text-left">
          Web Developer from Bangladesh
        </p>
        <div className="flex justify-center lg:justify-start items-center">
          <a
            href="https://drive.google.com/file/d/19aSi8BuZdB40ktPhZV6v-tWMxxA-xJNF/view?usp=sharing"
            target="_blank"
            
            className="btn border-2 bg-neon text-black hover:text-white mr-4 green-btn" rel="noreferrer"
          >
            <HiDownload className="mr-2 text-black hover:text-white" />
            Resume
          </a>

          <a
            href="https://github.com/Farhatmahi"
            className="btn border-2 bg-neon text-black hover:text-white"
          >
            <FiGithub className="mr-2 text-black hover:text-white" />
            Github
          </a>
        </div>
      </div>
    </div>
  );
};

export default Banner;
